import T from 'i18n';

// Document type options
export const DOC_TYPE_OPTIONS = [
  'pdf',
  'doc',
  'dot',
  'docx',
  'docm',
  'dotx',
  'dotm',
  'rtf',
  'xls',
  'xlt',
  'xlsx',
  'xlsm',
  'xltx',
  'xltm',
  'ppt',
  'pot',
  'pps',
  'pptx',
  'pptm',
  'potx',
  'potm',
  'ppsx',
  'ppsm',
  'odt',
  'ott',
  'fodt',
  'ods',
  'ots',
  'fods',
  'odp',
  'otp',
  'fodp',
  'odf',
  'odg',
  'otg',
  'fodg',
  'dwg',
  'dxf',
  'dwf',
  'dgn',
  'html',
  'htm',
  'xhtml',
  'xhtm',
  'msg',
  'eml',
  'txt',
  'csv',
  'dcm',
  'dicom',
  'dcim',
  'dicm',
  'tif',
  'tiff',
  'jpg',
  'jpeg',
  'jp2',
  'jpc',
  'gif',
  'png',
  'psd',
  'psb',
  'bmp',
  'dib',
  'pct',
  'pic',
  'pict',
  'wmf',
  'emf',
  'pcx',
  'dcx',
  'ras',
  'pcd',
  'tga',
  'tpic',
  'cal',
  'cals',
  'ico',
  'cur',
  'ncr',
  'xwd',
  'sgi',
  'wbmp',
  'sct',
  'wpg',
  'xbm',
  'pbm',
  'pgm',
  'ppm',
  'img',
  'cut',
  'mp4',
  'lp',
  'do',
  'zip',
  'xer',
  'plf',
  'inc',
  'mpp',
  'avi',
  'wmv',
  'xml',
  'xlsb',
  'dat',
  'pages',
  'p7s',
  'mht',
];

// Upfront filters that are always visible
export const getUpfrontFilters = () => [
  { key: 'trialBundles', label: T.translate('filters.trialBundles') },
  { key: 'recipients', label: T.translate('filters.recipients') },
  { key: 'authors', label: T.translate('filters.authors') },
  { key: 'date', label: T.translate('filters.date') },
];

// Additional filters shown when "More Filters" is expanded
export const getMoreFilters = () => [
  { key: 'annotations', label: T.translate('filters.annotations') },
  { key: 'classifySubtype', label: T.translate('filters.classifySubtype') },
  { key: 'classifyType', label: T.translate('filters.classifyType') },
  { key: 'dateUploaded', label: T.translate('filters.dateUploaded') },
  { key: 'docType', label: T.translate('filters.docType') },
  { key: 'flag', label: T.translate('filters.flag') },
  { key: 'hyperlinks', label: T.translate('filters.hyperlinks') },
  { key: 'merged', label: T.translate('filters.merged') },
  { key: 'pageCount', label: T.translate('filters.pageCount') },
  { key: 'privateBundles', label: T.translate('filters.privateBundles') },
  { key: 'teamBundles', label: T.translate('filters.teamBundles') },
  { key: 'visibility', label: T.translate('filters.visibility') },
];
